import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';


const Pagination = ({ prev, next, goToPage, currentPage, totalPages }) => {
  const [pageNumbers, setPageNumbers] = useState([1, 2, 3]);
  const numOfPages = totalPages ? [...Array(totalPages+1).keys()].slice(1) : [1];
  useEffect(() => {
    let newPageNumbers = [];
    if (currentPage < 3 ) {
      newPageNumbers = numOfPages.slice(0,3);
    } else if (currentPage === numOfPages.length) {
      newPageNumbers = numOfPages.slice(Math.max(numOfPages.length-3, 0))
    } else {
      newPageNumbers = [currentPage-2, currentPage-1, currentPage]
    }
    setPageNumbers(newPageNumbers);
  },[currentPage, totalPages]);
  return (
    <div className='d-flex fs-20'>
      {(currentPage != 1) &&
        <div>
          <button className='mt-5 blog-pagination-btn' onClick={prev}>
            <FontAwesomeIcon icon={faChevronLeft} size={'sm'} style={{margin: '5px 5px'}}/>
          </button>
          {currentPage > 3 &&
            <button className='blog-pagination-btn' onClick={() => goToPage(1)}>...</button>
          }
        </div>
      }
      {pageNumbers.map((num, index) => (
        <button key={index} className={clsx('mt-5 blog-pagination-btn', {'text-decoration-underline': num === currentPage})} onClick={() => goToPage(num)}>
          {num}
        </button>
      ))}
      {(currentPage != totalPages) &&
        <div>
          {currentPage != totalPages-1 && totalPages != 3 &&
            <button className='blog-pagination-btn' onClick={() => goToPage(totalPages)}>...</button>
          }
          <button className='mt-5 blog-pagination-btn' onClick={next}>
            <FontAwesomeIcon icon={faChevronRight} size={'sm'} style={{margin: '5px 5px'}}/>
          </button>
        </div>
      }
    </div>
  )
}

export default Pagination
